import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import AuctionFilter from "./components/AuctionFilter";
import AwardedStatsBanner from "./components/AwardedStatsBanner";
import { motion } from "motion/react";

export default function AuctionsPage() {
  return (
    <div className="min-h-screen bg-[#FAFAF8] font-['Noto_Sans_KR']">
      <Navbar />
      <main className="pt-24 pb-16 px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          {/* KPI Stats Banner */}
          <AwardedStatsBanner />

          {/* Page Header */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, ease: [0.25, 0.1, 0.25, 1] as const }}
            className="mb-8"
          >
            <div className="flex items-center gap-2 mb-2">
              <i className="ri-star-line text-[#C4956A]"></i>
              <span className="text-xs font-medium text-[#C4956A]">전문가 큐레이션</span>
            </div>
            <h1 className="text-2xl md:text-3xl font-bold text-[#1C1917] mb-2">
              전문가 PICK
            </h1>
            <p className="text-sm text-[#8C8780] max-w-[600px]">
              강스터디 전문가가 직접 분석하고 선별한 투자 추천 물건입니다. 
              단순 데이터 나열이 아닌, 하나하나 권리분석과 수익성을 검토한 알짜 물건만 모았습니다.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.15, duration: 0.5, ease: [0.25, 0.1, 0.25, 1] as const }}
          >
            <AuctionFilter />
          </motion.div>
        </div>
      </main>
      <Footer />
    </div>
  );
}